(function () {
  var d = document.getElementById('PivSub');
  if (!d || typeof d.showModal !== 'function') return;
  var KEY_DISMISS = 'pivSubDismissed', KEY_DONE = 'pivSubDone', HIDE_DAYS = 30;
  var DELAY_MS = 20000, SCROLL_RATIO = 0.5, SCROLL_MIN_MS = 8000;
  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  var form = d.querySelector('form');
  var msg = d.querySelector('.piv-sub__msg');
  var btn = form.querySelector('button[type=submit]');
  var main = d.querySelector('.piv-sub__main');
  var done = d.querySelector('.piv-sub__done');
  var flag = d.querySelector('.piv-sub__flag');

  d.addEventListener('click', function (e) {
    if (e.target === d || e.target.closest('[data-piv-close]')) d.close();
  });
  d.addEventListener('close', function () {
    if (!get(KEY_DONE)) set(KEY_DISMISS, String(Date.now()));
  });

  // The form posts natively (Shopify adds its spam-protection token on a real submit);
  // the page comes back with ?customer_posted=true, and we show the result in the popup.
  form.addEventListener('submit', function () {
    btn.textContent = 'Subscribing…';
    setTimeout(function () { btn.disabled = true; }, 0);
    setTimeout(function () { btn.disabled = false; btn.textContent = 'Subscribe'; }, 20000);
  });

  var posted = /[?&]customer_posted=true(&|$)/.test(location.search) || (flag && flag.getAttribute('data-state') === 'success');
  var errored = !posted && flag && flag.getAttribute('data-state') === 'error';
  if (posted || errored) {
    if (posted) {
      set(KEY_DONE, '1');
      main.hidden = true;
      done.hidden = false;
    } else {
      msg.textContent = 'That email address doesn’t look right. Please check it and try again.';
    }
    try {
      var u = new URL(location.href);
      u.searchParams.delete('customer_posted'); u.searchParams.delete('form_type'); u.searchParams.delete('utf8'); u.searchParams.delete('contact[tags]');
      history.replaceState(null, '', u.pathname + (u.search || ''));
    } catch (e) {}
    d.showModal();
    var h = (posted ? done : form).querySelector(posted ? 'h2' : 'input');
    if (h) h.focus();
    return;
  }

  var force = /[?&]piv_sub=1(&|$)/.test(location.search);
  if (!force) {
    if (get(KEY_DONE)) return;
    var t = parseInt(get(KEY_DISMISS) || '0', 10);
    if (t && Date.now() - t < HIDE_DAYS * 86400000) return;
  }

  var started = Date.now(), shown = false, timer = null;
  function cleanup() { clearTimeout(timer); window.removeEventListener('scroll', onScroll); }
  function show() {
    if (shown) return;
    if (document.querySelector('dialog[open]') || document.getElementById('shopify-pc__banner')) { timer = setTimeout(show, 6000); return; }
    shown = true;
    cleanup();
    d.showModal();
  }
  function onScroll() {
    if (Date.now() - started < SCROLL_MIN_MS) return;
    var h = document.documentElement;
    if ((window.scrollY + window.innerHeight) / h.scrollHeight >= SCROLL_RATIO) show();
  }

  if (force) { shown = true; d.showModal(); return; }
  timer = setTimeout(show, DELAY_MS);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
